export const common = {
  'pd-processing-policy-file-name': 'pd_processing_policy_ru.pdf',
  'pd-processing-policy-file-name-am': 'pd_processing_policy_am_ru.pdf',
  'pd-processing-policy-file-name-kz': 'pd_processing_policy_kz_ru.pdf',
  'pd-processing-policy-file-name-kg': 'pd_processing_policy_kg_ru.pdf',
  'pd-processing-policy-file-name-uz': 'pd_processing_policy_uz_ru.pdf',
  'user-agreement-sm-podbor-file-name': 'user_agreement_sm_podbor_ru.pdf',
  'accept-agreement-to-continue': 'Для дальнейших действий необходимо подтвердить согласие на обработку данных',
  'i-accept-user-data-proccesing': 'Я даю согласие на обработку своих персональных данных',
  yes: 'Да',
  no: 'Нет',
  continue: 'Продолжить',
  start: 'Начать',
  skip: 'Продолжить',
  delete: 'Удалить',
  cancel: 'Отмена',
  registration: 'Регистрация',
  russia: 'Россия',
  ukraine: 'Украина',
  belarus: 'Беларусь',
  'cookie-agreement': `
    Мы используем cookie файлы, чтобы адаптировать предложения в соответствии с твоими потребностями
    и обеспечить максимальное удобство при взаимодействии с сайтом.
    <a
      href="/user_agreement_sm_podbor_ru.pdf"
      target="_blank"
      class="text-neutral-700 hover:underline"
    >
      Узнать больше об использовании файлов cookie.
    </a>
    Продолжая пользоваться сайтом, ты соглашаешься с использованием файлов cookie.
  `,
  'accept-and-close': 'Принять и закрыть',
  'action-confirmation': 'Подтверждение действия',
  'execute-action': 'Выполнить действие?',
  ok: 'Ок',
  'choose-date': 'Выбери дату',
  'birth-date': 'Дата рождения',
  'add-resume': 'Добавь резюме',
  'invalid-file-type': 'Недопустимый тип файла',
  'cannot-load-stores': 'Не удалось загрузить данные магазина. Обратись к администраторам.',
  'nothing-found': 'Ничего не найдено',
  'store-business-card': 'Визитка магазина',
  'date-time-creation': 'Дата/время создания',
  vacancy: 'Вакансии',
  store: 'Магазин',
  'file-upload-error': 'Ошибка загрузки файла. Повторите попытку',
  'file-remove-error': 'Ошибка удаления файла. Повторите попытку',
  'file-upload-success': 'Файл успешно загружен',
  'file-remove-success': 'Файл успешно удалён',
  'file-already-uploaded': 'Вы уже загрузили этот файл',
};
